import { render, staticRenderFns } from "./activities-container.vue?vue&type=template&id=3e2ddcf8&scoped=true"
import script from "./activities-container.vue?vue&type=script&lang=js"
export * from "./activities-container.vue?vue&type=script&lang=js"
import style0 from "./activities-container.vue?vue&type=style&index=0&id=3e2ddcf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2ddcf8",
  null
  
)

export default component.exports